import { Layout, Menu, Icon } from "antd";
import React from "react";
import './SideBar.css';
const { Header } = Layout;
const { Sider } = Layout;

export class SideBarItem {
  _key: string;
  _label: string;
  _icon: ?string;
  constructor(key: string, label: string, icon: ?string = null) {
    this._key = key;
    this._label = label;
    this._icon = icon;
  }

  getKey() {
    return this._key;
  }
  getIcon() {
    return this._icon;
  }
  getLabel() {
    return this._label;
  }
}

export type SideBarProps = {
  sideBarItems: SideBarItem[],
  onSelect: SideBarItem => void,
  selectedKey: string
};
function SideBar(props: SideBarProps) {
  return (
    <Sider
      breakpoint="lg"
      collapsedWidth="0"
      collapsible={true}
      width="180"
      onBreakpoint={broken => {
        console.log(broken);
      }}
      onCollapse={(collapsed, type) => {
        console.log(collapsed, type);
      }}
    >
      <SideBarMenuItems
        sideBarItems={props.sideBarItems}
        onSelect={props.onSelect}
        selectedKey={props.selectedKey}
      />
    </Sider>
  );
}

function SideBarMenuItems(props: SideBarProps) {
  return (
    <Menu
      theme="dark"
      mode="vertical-left"
      defaultSelectedKeys={["4"]}
      selectedKeys={[props.selectedKey]}
      onClick={function(e) {
        const item = props.sideBarItems.find(function(i) {
          return i.getKey() === e.key;
        });
        if (item)
          //$FlowFixMe
          props.onSelect(item);
      }}
    >
      <Header> 
          <button className="dashboardHeader" onClick={()=>{props.onSelect(props.sideBarItems[0])}}>
              evolphin
          </button>
      </Header>
      {props.sideBarItems.map(function(item: SideBarItem) {
        return (
          <Menu.Item key={item.getKey()}>
            {item.getIcon() ? <Icon type={item.getIcon()} /> : null}
            <span className="nav-text">{item.getLabel()}</span>
          </Menu.Item>
        );
      })}
    </Menu>
  );
}

export default SideBar;
